import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 text-left" }
const _hoisted_2 = {
  for: "name",
  class: "block text-sm font-medium leading-6 text-gray-900"
}
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = ["disabled"]

import { useFocus } from "@vueuse/core";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useTrackEvent } from "shared/composables/tracking";
import { useCreateOrUpdateDashboard } from "@/composables/dashboard";
import { DashboardType, DashboardWidget } from "@/types/Dashboard";


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardNameModal',
  props: {
    dashboardNameModalType: {}
  },
  emits: ["close", "update"],
  setup(__props: any, { emit: __emit }) {

const { createOrUpdateDashboard, isLoading: isDashboardCreatingOrUpdating } =
  useCreateOrUpdateDashboard();

const props = __props;
const emit = __emit;

const { t } = useI18n();

const dashboardName = ref("");
const nameInput = ref<HTMLInputElement | null>();
useFocus(nameInput, { initialValue: true });

const trackEvent = useTrackEvent();
const router = useRouter();

const handleSaveClick = async () => {
  if (dashboardName.value && !isDashboardCreatingOrUpdating.value) {
    handleDashboardNameUpdate();
  }
};

const handleClose = () => {
  if (!isDashboardCreatingOrUpdating.value) {
    emit("close");
  }
};

const handleDashboardNameUpdate = () => {
  if (!props.dashboardNameModalType) {
    return;
  }
  createOrUpdateDashboard({
    name: dashboardName.value,
    widgets: [] as DashboardWidget[],
    version: 1,
    type: props.dashboardNameModalType,
    default: false,
  })
    .then((dashboard) => {
      if (dashboard) {
        router.push({
          name: "ProjectOverview",
          query: { id: dashboard._id, addWidget: "true" },
        });
      }
      emit("close");
    })
    .catch(() => undefined);

  trackEvent("dashboard_create", { type: props.dashboardNameModalType });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: true,
    onClose: handleClose,
    customCls: "w-full lg:w-[400px] m-2"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("dashboard.create_dashboard_modal.title")), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_unref(t)("dashboard.create_dashboard_modal.name")), 1),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              ref_key: "nameInput",
              ref: nameInput,
              type: "text",
              name: "name",
              autocomplete: "one-time-code",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dashboardName).value = $event)),
              onKeyup: _withKeys(handleSaveClick, ["enter"]),
              class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-yellow-600 sm:text-sm sm:leading-6"
            }, null, 544), [
              [_vModelText, dashboardName.value]
            ])
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          onClick: handleSaveClick,
          disabled: _unref(isDashboardCreatingOrUpdating),
          class: "focus:outline-none inline-flex gap-2 w-full items-center justify-center rounded-md border border-transparent bg-yellow-600 px-4 py-2 font-medium text-white shadow-sm hover:bg-yellow-700 disabled:bg-gray-200"
        }, [
          (_unref(isDashboardCreatingOrUpdating))
            ? (_openBlock(), _createBlock(LoadingSpinner, {
                key: 0,
                size: "w-5 h-5"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref(t)("dashboard.create_dashboard_modal.submit")), 1)
        ], 8, _hoisted_4)
      ])
    ]),
    _: 1
  }))
}
}

})